import { firebaseDb, ServerTimestamp } from '../firebase/'
import { addNotification } from './notification'

export const loadOrganization = () => (
  dispatch => {
    firebaseDb.collection('organization').onSnapshot(snapshot => (
      dispatch({
        type: 'LOAD_ORGANIZATION',
        snapshot
      })
    ), err => {
      console.log('Encountered error', err);
    })
  }
)
export const changeOrganizationInitStatus = status => ({
  type: 'CHANGE_ORGANIZATION_INIT_STATUS',
  status
})
export const showOrganizationEditForm = (teamId, members) => (
  dispatch => {
    dispatch(changeOrganizationInitStatus(true))
    dispatch({
      type: 'SHOW_ORGANIZATION_EDIT_FORM',
      teamId,
      members
    })
  }
)
export const hideOrganizationEditForm = () => ({
    type: 'HIDE_ORGANIZATION_EDIT_FORM'
})
export const addTeamMember = values => (
  dispatch => {
    let members = values.members? values.members : []
    if(values.user && !members.includes(values.user)){
      members.push(values.user)
      dispatch(updateTeamMember(values.teamId, members, values.user, 'add'))
    }
    dispatch(hideOrganizationEditForm())
  }
)
export const deleteTeamMember = (teamId, members, uid) => (
  dispatch => {
    dispatch(updateTeamMember(teamId, members.filter(value => value !== uid), uid, 'delete'))
  }
)
export const updateTeamMember = (teamId, members, uid, status) => (
  dispatch => {
    firebaseDb.runTransaction(transaction => {
      return transaction.get(firebaseDb.collection("users").doc(uid)).then(function(userDoc) {
        // Get user data
        let userTeams = userDoc.data().teams? userDoc.data().teams: []
        if(status === 'add'){
          userTeams.push(teamId)
        }else if(status === 'delete'){
          userTeams = userTeams.filter(value => value !== teamId)
        }

        // Update DB
        transaction.update(firebaseDb.collection('organization').doc(teamId), { 
          members: members,
          updated: ServerTimestamp 
        })
        transaction.update(firebaseDb.collection("users").doc(uid), { 
          teams: userTeams,
          updated: ServerTimestamp 
        })
        return Promise.resolve(true)
      })
    }).then(() => {
      dispatch(addNotification("更新しました", "success"))
    }).catch(err => {
      console.log('Encountered error', err)
      dispatch(addNotification("更新に失敗しました", "error"))
    })
  }
)



// WEBPACK FOOTER //
// ./src/actions/organization.js